import React from 'react';

export function AccountTab() {
  return (
    <div className="space-y-4">
      <p className="text-sm font-medium" style={{ color: 'var(--color-text)' }}>
        Account
      </p>
      <p className="text-xs" style={{ color: 'var(--color-text)', opacity: 0.6 }}>
        Account settings coming soon.
      </p>
    </div>
  );
}
